module.exports = __webpack_public_path__ + "img/committedtodevelopment_white.da3a8973.svg";